import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const Clock = ({ timezone }) => {
  const [time, setTime] = useState(getCurrentTime(timezone));

  function getCurrentTime(tz) {
    const now = new Date();

    const date = now.toLocaleDateString("en-US", {
      timeZone: tz,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    const time = now.toLocaleTimeString("en-US", {
      timeZone: tz,
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZoneName: "short",
    });

    return `${date} ${time}`;
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(getCurrentTime(timezone));
    }, 1000);

    return () => clearInterval(timer);
  }, [timezone]);

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id="custom-clock-tooltip">
          Times reflect account time zone (may differ from your local time)
        </Tooltip>
      }
    >
      <span
        className="fw-medium text-white"
        style={{
          fontSize: "14px",
          letterSpacing: "0.1px",
          whiteSpace: "nowrap",
          lineHeight: "20px",
        }}
      >
        {time}
      </span>
    </OverlayTrigger>
  );
};

// Prop type validation
Clock.propTypes = {
  timezone: PropTypes.string.isRequired,
};

export default Clock;
